// tslint:disable
export const dicoGOPCO = {
    id: "1",
    cover: {
        image: "pco",
        title: "Prima Capital Obsèques +",
        target: "Particuliers âgés de 18 ans à 85 ans<sup>(1)</sup>.",
        topic: "Un contrat d’assurance vie permettant le versement d’un capital de 1 000 € à 18 400 € au(x) bénéficiaire(s) désigné(s).",
        tag: "Obsèques",
        age: "18 / 85 ans",
    },
    conditions: [
        "Adhésion possible jusqu’à 85 ans <sup>(1)</sup> sans formalité médicale.",
        "Souscription éligible en France métropolitaine et DROM.",
        "L’adhésion peut le cas échéant être réalisée à distance.",
    ],
    plus: [
        { icon: "shield", text: "Couverture immédiate en cas d’accident." },
        { icon: "currency", text: "Libre choix du capital entre 1 000 et 18 400 €." },
        { icon: "edit", text: "Adhésion jusqu’à 85 ans<sup>(1)</sup> et sans questionnaire médical." },
        { icon: "account", text: "Désignation libre du (des) bénéficiaire(s)" },
        { icon: "calcul", text: "10% de réduction sur la cotisation du conjoint." },
        { icon: "propal", text: "Une fiscalité avantageuse : capital exonéré des droits de succession<sup>(2)</sup>." },
    ],

    /* DOCUMENTS ANNEXES */

    docs: {
        adhesion: [
            {
                label: "Notice d’information",
                url: require("./documents/adhesion/prima_capital_obseques_plus_notice_information.pdf"),
                required: true,
            },
            {
                label: "Annexe désignation de bénéficiaire(s) : clauses libres",
                url: require("./documents/adhesion/annexe_designation_clause_beneficiaire.pdf"),
                required: false,
            },
            {
                label: "Document d'information",
                url: require("./documents/adhesion/document_information.pdf"),
                required: true,
            },
        ],
        common: [
            {
                label: "Plaquette commerciale",
                url: require("./documents/common/plaquette_commerciale_obseques.pdf"),
                required: false,
            },
            {
                label: "Convention d'assistance",
                url: require("./documents/common/convention_assistance_obseques.pdf"),
                required: false,
            },
            {
                label: "Guide des démarches obsèques",
                url: require("./documents/common/guide_des_demarches_obseques.pdf"),
                required: false,
            },
            {
                label: "Attestation de mise à disposition des documents clés",
                url: require("./documents/common/documents_cles_PCO.pdf"),
                required: true,
            },
            {
                label: "Dossier d’Entrée en Relation (DER)",
                url: require("./documents/common/DER_dossier_entree_en_relation.pdf"),
                required: true,
            },
        ],
    },

    /********************/

    summary: {
        image: "pco",
        paragraphs: [
            {
                headline: "Niveaux de garanties",
                text: "Choix à l’adhésion d’un capital compris entre 1 000 € et 18 400 €.",
            },
            {
                headline: "Délai de carence",
                text: "Six mois sauf en cas de décès accidentel.",
            },
            {
                headline: "Cotisations",
                text: "Le montant de la cotisation est fixé en fonction de l’âge de l’adhérent à la date d’effet de l’adhésion et du montant du capital garanti.",
            },
        ],
    },
    details: {
        paragraphs: [
            {
                headline: "Date d’effet du contrat",
                text: "Sous réserve de l’encaissement de la 1ère cotisation, l’adhésion prend effet au 1er jour du mois suivant la réception des documents d’adhésion par l’assureur<br />La date d’effet est indiquée sur le certificat d’adhésion.",
            },
            {
                headline: "Formalités en cas de décès",
                text: "Le décès de l’assuré entraîne le versement d’un capital garanti sous 3 jours ouvrés maximum à réception des pièces justificatives. Ce capital est mis à disposition du (des) bénéficiaire(s) qui produit (produisent) les pièces justificatives suivantes :<ul><li>le certificat d’adhésion,</li><li>un acte de décès,</li><li>une copie de sa pièce d’identité,</li><li>son relevé d’identité bancaire ou postal.</li></ul>",
            },
            {
                headline: "Périodicité des cotisations",
                text: "La cotisation est payable<ul><li>Soit en prime unique<sup>(1)</sup>,</li><li>Ou soit en prime temporaire de 5 à 15 ans (annuelle, trimestrielle ou mensuelle).</li></ul>",
            },
            {
                headline: "Rachat",
                text: "<ul><li>Seul le rachat total est permis, les rachats partiels ne sont pas autorisés. </li><li>Le rachat est possible dès sa prise d’effet, à condition que la valeur de rachat ne soit pas nulle sous déduction des incidences fiscales et sociales prévues par les dispositions en vigueur à la date de rachat.</li></ul>",
            },
            {
                headline: "Assistance",
                text: "<ul><li>Rapatriement ou transport du corps.</li><li>Retour des proches voyageant avec le défunt.</li><li>Venue d’une personne la nuit suivant le décès.</li><li>Aide ménagère au domicile du défunt.</li><li>Accompagnement psychologique.</li><li>Assistance administrative par téléphone.</li><li>Informations juridiques et pratiques.</li><li>Gardiennage du domicile du défunt.</li> </ul>",
            },
        ],
        mentions: [
            "<sup>(1)</sup> L’âge limite d’adhésion varie en fonction de la périodicité de la prime. L’âge limite d’adhésion en prime unique est de 69 ans inclus. (Cf. Notice d’information)",
            "<sup>(2)</sup> Dans les limites fiscales en vigueur et hors prélèvements sociaux.",
        ],
    },
    benchmark: {
        title: "Prima Capital Obsèques +",
        head: [
            { headline: "" },
            { headline: "ag2r La Mondiale", subheading: "Prima Capital Obsèques +" },
            { headline: "CREDIT MUTUEL", subheading: "Previ-Obsèques" },
            { headline: "BANQUE POSTALE ", subheading: "Solution Obsèques" },
            { headline: "CREDIT AGRICOLE ", subheading: "Assurance Obsèques" },
        ],
        body: [
            {
                cells: [
                    "Type de prime / Âge limite périodicité",
                    "• Prime temporaire : 80 ans<br>• Prime unique : 69 ans",
                    "• Prime viagère : 85 ans<br>• Prime temporaire : 85 ans<br>• Prime unique : 85 ans",
                    "• Prime viagère : 85 ans<br>• Prime temporaire : 85 ans",
                    "• Prime temporaire : 85 ans<br>• Prime unique : 85 ans",
                ],
            },
            {
                cells: ["Délai de carence", "6 mois", "12 mois", "12 mois", "12 mois"],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels (60 ans)",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime temporaire (10 ans) : 43,30 €<br>• Prime unique : 4 140,80 €",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime viagère : 21,27 €<br>• Prime temporaire (10 ans) : 38,04 €<br>• Prime unique : 3 583,82 €",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime viagère : 23,60 €<br>• Prime temporaire (10 ans) : 53,75 €",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime temporaire (10 ans) : 41 €<br>• Prime unique : 3977 €",
                ],
            },
            {
                highlight: true,
                cells: [
                    "Tarifs mensuels (70 ans)",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime temporaire (10 ans) : 47,70 €<br>• Prime unique : /",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime viagère : 39,48 €<br>• Prime temporaire (10 ans) : 45,83 €<br>• Prime unique : 3 923,43 €",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime viagère : 30,05 €<br>• Prime temporaire (10 ans) : 51,93 €",
                    "<u><i>Capital de 4 000 €</i></u><br>• Prime temporaire (10 ans) : 45 €<br>• Prime unique : 4000 €",
                ],
            },
        ],
    },
};



// WEBPACK FOOTER //
// ./src/data/products/go/dicoPCO.ts